module.exports = __webpack_public_path__ + "static/media/bm.0fdefae8.svg";